<template>
  <tr>
    <th>최초 전송 시간</th>
    <td>
      <span v-if="pushFirstDate">{{$utils.timeText(pushFirstDate)}}</span>
      <span v-else>-</span>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    pushFirstDate: [String, Date]
  }
};
</script>

<style>
</style>